<template>
  <v-layout wrap>
    <v-flex xs12 text-center>
      <img
        :src="require('../assets/club-thrive-logo.png')"
        alt="thrive"
        :width="width"
      />
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  name: 'Logo',
  props: {
    width: {
      default: 200,
      type: [Number, String]
    }
  }
};
</script>

<style lang="scss" scoped>
img {
  margin-bottom: 20px;
}
</style>
